module.exports = __webpack_public_path__ + "static/media/convertkit.c38a9475.svg";